
/*
 * ! @chakra-ui/vue v0.11.0 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

var closeButtonProps = {
  size: {
    type: String,
    default: 'md',
    validator: function validator(value) {
      return value.match(/^(sm|md|lg)$/);
    }
  },
  isDisabled: {
    type: Boolean,
    default: false
  },
  ariaLabel: {
    type: String,
    default: 'Close'
  }
};

var baseProps = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  rounded: 'md',
  transition: 'all 0.2s',
  flex: '0 0 auto',
  _hover: {
    bg: 'blackAlpha.100'
  },
  _active: {
    bg: 'blackAlpha.200'
  },
  _disabled: {
    cursor: 'not-allowed'
  },
  _focus: {
    boxShadow: 'outline'
  },
  border: 'none',
  bg: 'blackAlpha.50'
};
var sizes = {
  lg: {
    button: '40px',
    icon: '16px'
  },
  md: {
    button: '32px',
    icon: '12px'
  },
  sm: {
    button: '24px',
    icon: '10px'
  }
};

export { baseProps as b, closeButtonProps as c, sizes as s };
